<template>
  <div id="myModal" class="p_modal_viewer" v-if="showVar" @click.self="close('modal')">
    <!-- Modal content -->
    <div class="p_modal_viewer_content" :style="dameStyle">
      <div class="p_modal_viewer_title">
        <span class="p_modal_title_text">{{ title }}</span>
        <div class="p_modal_viewer_close">
          <span class="spanClose_PModal" v-if="showCloseIcon" @click="close('close')"
            ><PIcon icon="close" type="material"></PIcon
          ></span>
        </div>
      </div>
      <div class="p_modal_viewer_text" :style="dameStyleContent">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import PIcon from "@/components/look/PIcon/PIcon.vue";

@Component({
  components: {
    PIcon,
  },
})
export class PModal extends Vue {
  @Prop({ required: true }) show!: boolean;
  @Prop({ required: false, default: "" }) title!: string;
  @Prop({ required: false, default: 0 }) width!: number;
  @Prop({ required: false, default: 0 }) height!: number;
  @Prop({ required: false, default: true }) closeClickExit!: boolean;
  @Prop({ required: false, default: true }) showCloseIcon!: boolean;

  @Watch("show", { immediate: true })
  onChangeShow(): void {
    this.showVar = this.show;
  }
  public windowWidth: number;
  public windowHeight: number;
  public showVar: boolean;
  constructor() {
    super();
    this.windowWidth = 0;
    this.windowHeight = 0;
    this.showVar = false;
  }
  mounted(): void {
    this.$nextTick(function () {
      window.addEventListener("resize", this.getWindowWidth);
      window.addEventListener("resize", this.getWindowHeight);

      //Init
      this.getWindowWidth();
      this.getWindowHeight();
    });
  }
  close(quien: string): void {
    //div#myModal.p_modal_viewer

    if (quien === "modal" && this.closeClickExit) {
      this.$emit("close");
    }
    if (quien == "close") {
      this.$emit("close");
    }
  }
  get dameStyle(): string {
    if (this.height != 0 && this.width != 0) {
      return (
        "width:" +
        this.width * 0.9 +
        "px;min-height:" +
        this.height * 0.9 +
        "px;margin-top:" +
        (this.windowHeight - this.height) / 2 +
        "px;"
      );
    } else if (this.width != 0) {
      return (
        "width:" +
        this.width * 0.9 +
        "px;max-height:" +
        this.windowHeight * 0.9 +
        "px;margin-top:" +
        this.windowHeight * 0.05 +
        "px;"
      );
    } else if (this.height != 0) {
      return (
        "width:" +
        this.windowWidth * 0.9 +
        "px;min-height:" +
        this.height * 0.9 +
        "px;margin-top:" +
        this.height * 0.05 +
        "px;"
      );
    } else {
      return (
        "width:" +
        this.windowWidth * 0.9 +
        "px;max-height:" +
        this.windowHeight * 0.9 +
        "px;margin-top:" +
        this.windowHeight * 0.05 +
        "px;"
      );
    }
  }
  get dameStyleContent(): string {
    if (this.height != 0) {
      return "max-height:" + (this.height * 0.9 - 51) + "px";
    }

    return "";
  }

  getWindowWidth(): void {
    this.windowWidth = document.documentElement.clientWidth;
  }

  getWindowHeight(): void {
    this.windowHeight = document.documentElement.clientHeight;
  }
  beforeDestroy(): void {
    window.removeEventListener("resize", this.getWindowWidth);
    window.removeEventListener("resize", this.getWindowHeight);
  }
}
export default PModal;
</script>

<style lang="scss" scoped>
.p_modal_viewer {
  position: fixed; /* Stay in place */
  z-index: 5; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  background-color: rgba(0, 0, 0, 0.25); /* Black w/ opacity */
  overflow-x: hidden;
  overflow-y: auto;
}

/* Modal Content/Box */
.p_modal_viewer_content {
  max-width: 100%;
  position: relative;
  background-color: #ffffff;
  margin: 0 auto;
  padding: 0;
  border-radius: 6px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16);
}
.p_modal_viewer_text {
  position: relative;
  overflow: visible;
  height: 100%;
  background-color: #fff;
  padding-top: 0.5rem;
}
.modalViewerClose {
  cursor: pointer;
}
.p_modal_viewer_title {
  position: relative;
  padding: 14px 19px 13px 23px;
  width: 100%;
  height: 51px;
  border-radius: 6px 6px 0 0;
  letter-spacing: normal;
  box-shadow: 0 2px 5px 0 rgb(0 0 0 / 16%);
  background-color: var(--amarillo-prosegur);
  span.p_modal_title_text {
    height: 24px;
    font-family: Roboto, Arial, Helvetica, sans-serif;
    font-size: 16px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    color: var(--secundario-prosegur-oscuro);
    text-transform: uppercase;
  }
}
.p_modal_viewer_close {
  position: absolute;
  top: 1rem;
  right: 1rem;
}
.spanClose_PModal {
  cursor: pointer;
}
</style>
